import React, { useMemo } from "react"
import {
  Box,
  ResponsiveBox,
  useResponsiveWrapperContext,
} from "@usap/uicomponents"
import { Heading2 } from "@usap/widgets"
import EmptyCartWmo from "./EmptyCartWmo"
import useWmoEnabled from "../../../../hooks/useWmoEnabled"

const NoItemsInCart = () => {
  const { isDesktop } = useResponsiveWrapperContext()

  const style = useMemo(
    () => ({
      padding1: { bottom: "medium" },
      style1: { fontSize: isDesktop ? 24 : 16, color: "light-3" },
      border1: { color: "light-3", size: "xsmall" },
      padding2: { vertical: "8px", horizontal: "16px" },
    }),
    [isDesktop]
  )

  const isWmoEnabled = useWmoEnabled()

  if (isWmoEnabled) {
    return <EmptyCartWmo />
  }

  return (
    <ResponsiveBox
      fxWidth={{ large: "1248px", other: "300px" }}
      margin={{ horizontal: "auto", vertical: "0px" }}
    >
      <Box
        align="center"
        pad={{ vertical: "200px" }}
        margin={{ bottom: "medium" }}
      >
        <Heading2
          size={isDesktop ? "medium" : "small"}
          title="Your shopping cart is empty!"
          style={style.style1}
        />
      </Box>
    </ResponsiveBox>
  )
}

export default NoItemsInCart
